export default [
    'Duurzame bloemen',
    'Direct van \'t land',
    'New floral design',
    'Met zorg gebonden',
    'In heel NL bezorgd',
];